import { Navigate, Route, Routes, resolvePath, useLocation } from 'react-router-dom';

import PlacePage from './place';

export default function PlacesPage() {
  const location = useLocation();

  return (
    <Routes>
      <Route element={<PlacePage />} path=":place_id/*" />
      <Route element={<Navigate to={resolvePath('..', location.pathname)} />} path="*" />
    </Routes>
  );
}
